import { ROUTE_FETCHED } from "../types";

const initialState = [];

export default function routes(state = initialState, action) {
  switch (action.type) {
    case ROUTE_FETCHED:
      return [ ...state, ...action];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/routes.js